import type {FunctionComponent} from "react";
import {InfoOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import ToastContent from "../../index";

export interface IInfoToastContent {
    message: string,
    title?: string,
}

const InfoToastContent: FunctionComponent<ToastContentProps<IInfoToastContent>> = (props) => {

    return (
        <>
            <ToastContent
                title={props.data.title}
                message={props.data?.message ?? ''}
                icon={<InfoOutlined color={'info'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default InfoToastContent;
